/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_RejectedInputs */

const en_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const de_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

const fr_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeté`)
};

const es_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado`)
};

const it_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutato`)
};

const nl_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen`)
};

const pl_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucono`)
};

const fi_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylätty`)
};

const da_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvist`)
};

const sv_keyword_optimizer_reformulation_rejected = /** @type {(inputs: Keyword_Optimizer_Reformulation_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisat`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Keyword_Optimizer_Reformulation_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_rejected = /** @type {((inputs?: Keyword_Optimizer_Reformulation_RejectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_RejectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_rejected(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_rejected(inputs)
	return en_keyword_optimizer_reformulation_rejected(inputs)
});